
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_3izys_3",
  "input": "awsui_input_1sdq3_3izys_16",
  "results": "awsui_results_1sdq3_3izys_20",
  "results-visible": "awsui_results-visible_1sdq3_3izys_26"
};
  